export default "icons/search.svg"